export const REDIRECT_TO = "ROUTE.REDIRECT_TO";
export const REMOVE_REDIRECT_TO = "ROUTE.REMOVE_REDIRECT_TO";
